import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import SimpleHeader from '../../SimpleHeader';
import Footer from '../../Footer';
import Loadingpage from '../../Loadingpage';

// Styles
import styles from './index.module.sass';

import useDevice from '../../../hooks/useDevice';

const digitalCatalog = process.env.REACT_APP_DIGITAL;

export default function MyDigitalCatalog({ history, userAgent }) {
  const device = useDevice({ userAgent });
  const { kitNumber = '' } = useParams();

  return (
    <Suspense fallback={<Loadingpage />}>
      <div>
        <SimpleHeader />
        <div className={styles.catalogContainer}>
          <iframe
            title='Terramar Digital Catalog'
            src={`${digitalCatalog}/?kit=${kitNumber}`}
            frameBorder='0'
            style={{
              width: '100%',
              height: '100%',
            }}
            allow='autoplay; fullscreen;'
            allowFullscreen
            webkitallowfullscreen
            mozallowfullscreen></iframe>
        </div>
        <Footer device={device} history={history} />
      </div>
    </Suspense>
  );
}
